import { render, staticRenderFns } from "./ConfigAlertDingtalk.vue?vue&type=template&id=7b3d4986&scoped=true"
import script from "./ConfigAlertDingtalk.vue?vue&type=script&lang=js"
export * from "./ConfigAlertDingtalk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3d4986",
  null
  
)

export default component.exports